"use strict";

exports.__esModule = true;
exports.destroy = destroy;
exports.close = close;
exports.createDiv = createDiv;
exports.open = open;
exports.method = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("../Button"));

var _uid = require("../utils/uid");

var _styles = require("../styles");

var _Panel = _interopRequireDefault(require("./Panel"));

var _locale = require("../locale");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var containers = {};
var DURATION = 300;

function getDiv(id) {
  var mod = containers[id];
  return mod ? mod.div : null;
}

function hasVisible() {
  return Object.keys(containers).some(function (k) {
    return containers[k].visible;
  });
}

function isMask(id) {
  var ids = Object.keys(containers).filter(function (k) {
    return containers[k].visible;
  });
  if (ids.length === 0) return true;
  return ids[0] === id;
}

function destroy(id, unmount) {
  var div = getDiv(id);
  if (!div) return;
  delete containers[id];
  if (unmount) _reactDom.default.unmountComponentAtNode(div);
  document.body.removeChild(div);
}

function close(props) {
  var id = props.id;
  var modal = containers[props.id];
  if (!modal || modal.visible === false) return;
  modal.visible = false;
  var div = modal.div;
  div.classList.remove((0, _styles.modalClass)('show'));
  setTimeout(function () {
    div.style.display = 'none';
    if (props.destroy) destroy(id);

    if (!hasVisible()) {
      var doc = document.body.parentNode;
      doc.style.overflow = '';
      doc.style.paddingRight = '';
    }
  }, DURATION);
}

function createDiv(props) {
  var id = props.id;
  var div = getDiv(props.id);
  if (div) return div;
  div = document.createElement('div');
  document.body.appendChild(div);
  div.className = (0, _classnames.default)((0, _styles.modalClass)('_'));
  containers[id] = {
    div: div
  };
  return div;
} // eslint-disable-next-line


function open(props, isPortal) {
  var content = props.content,
      onClose = props.onClose,
      zIndex = props.zIndex,
      otherProps = _objectWithoutPropertiesLoose(props, ["content", "onClose", "zIndex"]);

  var div = createDiv(props);
  div.style.display = 'block';
  var parsed = parseInt(zIndex, 10);
  if (!Number.isNaN(parsed)) div.style.zIndex = parsed;
  var scrollWidth = window.innerWidth - document.body.clientWidth;
  var doc = document.body.parentNode;
  doc.style.overflow = 'hidden';
  doc.style.paddingRight = scrollWidth + "px";

  var handleClose = function handleClose() {
    if (onClose) onClose();
    if (!isPortal) close(props);
  };

  var maskOpacity = isMask(props.id) ? props.maskOpacity || 0.25 : 0.01;
  div.style.background = "rgba(0,0,0," + maskOpacity + ")";
  containers[props.id].visible = true;
  setTimeout(function () {
    div.classList.add((0, _styles.modalClass)('show'));
  }, 10);

  var panel = _react.default.createElement(_Panel.default, _extends({}, otherProps, {
    onClose: handleClose
  }), content);

  if (isPortal) return _reactDom.default.createPortal(panel, div);
  if (document.activeElement) document.activeElement.blur();

  _reactDom.default.render(panel, div);

  return null;
}

var closeCallback = function closeCallback(fn, option) {
  return function () {
    var callback;
    if (fn) callback = fn();

    if (callback && typeof callback.then === 'function') {
      callback.then(function () {
        close(option);
      });
    } else {
      close(option);
    }
  };
};

var btnOk = function btnOk(option) {
  var onClick = closeCallback(option.onOk, option);
  return _react.default.createElement(_Button.default.Once, {
    key: "ok",
    onClick: onClick,
    type: "primary"
  }, (0, _locale.getLocale)('ok', option.text));
};

var btnCancel = function btnCancel(option) {
  var onClick = closeCallback(option.onCancel, option);
  return _react.default.createElement(_Button.default.Once, {
    key: "cancel",
    onClick: onClick
  }, (0, _locale.getLocale)('cancel', option.text));
};

var method = function method(type) {
  return function (option) {
    var props = Object.assign({
      width: 420
    }, option, {
      id: (0, _uid.getUidStr)(),
      destroy: true,
      type: type
    });

    if (type === 'confirm') {
      props.footer = [btnCancel(props), btnOk(props)];
    } else {
      props.footer = [btnOk(props)];
    }

    open(props);
    return function () {
      return close(props);
    };
  };
};

exports.method = method;